import * as yup from 'yup';
import { lodgementTypeValues } from 'utils/constants';

yup.setLocale({
  mixed: {
    oneOf: '',
    required: '',
  },
});

const validationSchema = yup.object().shape({
  lodgement: yup.string().oneOf([...lodgementTypeValues]),
});

export default validationSchema;
